import React, { useState } from 'react';
import { motion } from 'framer-motion';

const textContainer = {
	initial: { opacity: 0, y: 20 },
	whileInView: { opacity: 1, y: 0 },
	transition: { duration: 0.8, ease: 'easeOut' }
};

const DEFAULT_IMAGE = '/images/color-wires.png';
const FALLBACK_IMAGE = '/images/color-wires.png';

const CareersBanner = () => {
	const [imgSrc, setImgSrc] = useState(DEFAULT_IMAGE);

	return (
		<section className="relative bg-white overflow-hidden min-h-[420px] sm:min-h-[520px] md:min-h-[600px] lg:min-h-[680px]">
			{/* Decorative lime accents at the top to mirror the design */}
			<div className="absolute top-0 left-0 right-0 flex justify-between px-6  pt-2">
				<div className="h-1 w-24 bg-lime-400 rounded" />
				<div className="h-1 w-16 bg-lime-400 rounded" />
				<div className="h-1 w-10 bg-lime-400 rounded" />
				<div className="h-1 w-24 bg-lime-400 rounded" />
			</div>

			{/* Headline over image with reserved bottom space */}
			<div className="relative max-w-7xl mx-auto px-6 sm:px-8 md:px-12 pt-28 md:pt-32 pb-[38%] sm:pb-[40%] md:pb-[44%] lg:pb-[46%] flex items-start md:items-center justify-center">
				<motion.div
					initial={textContainer.initial}
					whileInView={textContainer.whileInView}
					viewport={{ once: true, amount: 0.6 }}
					transition={textContainer.transition}
					className="text-center relative z-10"
				>
					<motion.h1 
						className="font-source italic leading-tight text-black font-light"
						style={{ fontSize: 'clamp(1.875rem, 4vw + 1rem, 10.5rem)' }}
					>
						Clarity
					</motion.h1>
					<motion.p 
						className="mt-2 sm:mt-3 text-black font-source font-regular"
						style={{ fontSize: 'clamp(1.125rem, 2.5vw + 0.5rem, 6.875rem)' }}
					>
						build futures together
					</motion.p>
				</motion.div>
			</div>

			{/* Bottom-anchored braided image to match reference layout */}
			<motion.img
				src={imgSrc}
				onError={() => setImgSrc(FALLBACK_IMAGE)}
				alt="Multicolor braided cables"
				className="absolute inset-x-0 bottom-0 w-full h-[100%] sm:h-[100%] md:h-[100%] lg:h-[100%] object-cover select-none pointer-events-none"
				style={{ objectPosition: 'center bottom' }}
				initial={{ x: -6 }}
				animate={{ x: [ -6, 6, -6 ] }}
				transition={{ repeat: Infinity, duration: 16, ease: 'easeInOut' }}
			/>
		</section>
	);
};

export default CareersBanner;


